<template>
  <div id="app">
    <router-view />
    <!-- 显示加载中遮罩层 start -->
    <transition name="fade">
      <div v-show="$store.state.loading" class="loading-part">
        <div class="loading-part-bg"></div>
        <div class="loading-part-icon">
          <span class="el-icon-loading"></span>
        </div>
      </div>
    </transition>
    <!-- 显示加载中遮罩层 end -->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.loading-part {
  position: fixed;
  z-index: 9999997;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
}
.loading-part-bg {
  position: absolute;
  z-index: 9999998;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  background: #000;
  opacity: 0.06;
}
.loading-part-icon {
  position: absolute;
  z-index: 9999999;
  top: calc(40vh);
  left: 50%;
  margin-left: -30px;
  font-size: 60px;
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/App.vue